<svelte:options customElement={{
  tag: 'news-pager',
  shadow: 'none',
  props: {
    currentPage: { reflect: true, type: 'Number', attribute: 'current-page' },
    totalPages: { reflect: true, type: 'Number', attribute: 'total-pages' }
  }
}} />

<script>
  import { createEventDispatcher } from 'svelte';
  import SvgIcon from './SvgIcon.svelte';

  /**
   * ページネーション
   * @prop {number} currentPage  - 現在のページ番号
   * @prop {number} totalPages   - 総ページ数
   */
  export let currentPage = 1;
  export let totalPages = 1;

  const dispatch = createEventDispatcher();

  $: pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  function goTo(page) {
    if (page < 1 || page > totalPages) return;
    dispatch('pagechange', { page });
  }
</script>

{#if totalPages > 1}
<nav class="mod-pager rt_bn_pager" aria-label="ページネーション">
  <button class="mod-pager__btn" on:click={() => goTo(1)} disabled={currentPage === 1} aria-label="最初のページ">
    <SvgIcon name="arrow_left_double" size="sm" />
  </button>
  <button class="mod-pager__btn" on:click={() => goTo(currentPage - 1)} disabled={currentPage === 1} aria-label="前のページ">
    <SvgIcon name="arrow_left" size="sm" />
  </button>
  {#each pageNumbers as page}
    <button
      class="mod-pager__page{currentPage === page ? ' __active' : ''}"
      on:click={() => goTo(page)}
      aria-label="{page}ページ"
      aria-current={currentPage === page ? 'page' : null}
    >{page}</button>
  {/each}
  <button class="mod-pager__btn" on:click={() => goTo(currentPage + 1)} disabled={currentPage === totalPages} aria-label="次のページ">
    <SvgIcon name="arrow_right" size="sm" />
  </button>
  <button class="mod-pager__btn" on:click={() => goTo(totalPages)} disabled={currentPage === totalPages} aria-label="最後のページ">
    <SvgIcon name="arrow_right_double" size="sm" />
  </button>
</nav>
{/if}
